export const SET_NAVIGATION_KEY = 'SET_NAVIGATION_KEY';
